import { AuthProvider } from '../../definitions/CommonDefinitions'
import { LoginSource } from '../../services/definitions/IAnalyticsService'
import { LinkService } from '../../services/LinkService'
import { AnalyticsService } from '../../services/AnalyticsService'
import { EventService } from '../../services/EventService'
import { AuthenticationService } from '../../services/AuthenticationService'
import { FormInput } from '../flipp-form-input/FormInput'

/* eslint-disable */
export const EMAIL_REGEXP =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const handleFormInputsChange = (state: any, refs: any, e: any) => {
    Object.keys(refs).forEach((name) => {
        if (name.includes('Input')) {
            ;(refs[name] as FormInput).errorMessage = ''
        }
        if (name.includes('ErrorMsg')) {
            ;(refs[name] as HTMLElement).textContent = ''
        }
    })
    return { ...state, [e.target.name]: e.target.value }
}

export const handleLogin = (
    userId: string,
    target: EventTarget,
    redirectUri = 'weekly_ads'
) => {
    const analyticsService = AnalyticsService.getInstance()
    analyticsService.setAccountGuid(userId)
    analyticsService.trackSignin(userId, AuthProvider.EMAIL, LoginSource.Signin)
    EventService.getInstance().fireAuthEvent('login', null, this)
    LinkService.getInstance().execute(redirectUri, target)
}

export const hasEmptyFields = (obj: any) => {
    return Object.keys(obj).some((name) => !(obj as any)[name])
}

export const handleSubmitRequest = async (
    refs: {
        submitBtn: HTMLElement
        submitBtnText: HTMLElement
        spinner: HTMLElement
        responseErrorMsg: HTMLElement
    },
    request: () => void,
    onError?: (body: any) => void
) => {
    refs.submitBtn.setAttribute('disabled', '')
    refs.submitBtnText.classList.add('hide')
    refs.spinner.classList.remove('hide')
    try {
        await request()
    } catch (e) {
        if (e.message) {
            EventService.getInstance().fireAuthEvent('error', e.message, this)
            refs.responseErrorMsg.textContent = e.message
            if (onError) onError(e)
        }
    } finally {
        refs.submitBtn.removeAttribute('disabled')
        refs.submitBtnText.classList.remove('hide')
        refs.spinner.classList.add('hide')
    }
}

export const handleResendActionRequest = async (
    e: any,
    refs: {
        resendCodeBtn: HTMLElement
        resendCodeSpinner: HTMLElement
    },
    email: string,
    onSuccess?: () => void
) => {
    e.preventDefault()
    refs.resendCodeBtn.style.display = 'none'
    refs.resendCodeSpinner.style.display = 'inline-flex'
    try {
        await AuthenticationService.getInstance().resendConfirmationCode(email)
        onSuccess()
    } catch (e) {
        console.log(e)
    } finally {
        refs.resendCodeBtn.style.display = 'inline'
        refs.resendCodeSpinner.style.display = 'none'
    }
}

export const setDocumentTitle = (pageName: string) => {
    document.title = `${pageName} | Flipp`
}
